// libs
import React, { memo, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';
import { styled } from '@nykaa/ui-components';

// global components
import FitCode from 'shared/components/FitCode';

// constants
import { FITCODE_RESULTS } from 'shared/constants/uri';
import { FITCODE_URL } from 'shared/components/FitCode/constants';

// styles
const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

function FitcodeSurvey() {
  const history = useHistory();
  const { search } = useLocation();

  const onCancel = useCallback(() => {
    history.goBack();
  }, [history]);

  const onSubmit = useCallback(() => {
    const params = new URLSearchParams(search);

    // if survey came from retake we should go back
    if (params.has('from') && params.get('from') === 'retake') {
      history.goBack();
      return;
    }

    history.replace(FITCODE_RESULTS);
  }, [history, search]);

  return (
    <Container>
      <FitCode onSubmit={onSubmit} onCancel={onCancel} fitcodeEndpoint={FITCODE_URL} />
    </Container>
  );
}

export default memo(FitcodeSurvey);
